module.exports = __webpack_public_path__ + "static/img/doge-tile.b72076d4.png";